{
  "startSpeed": 12,
  "maxSpeed": 30,
  "boostSpeed": 45,
  "boostAccel": 6,
  "gravityAccel": 8,
  "pedalAccel": 4,
  "pedalCapBonus": 3,
  "braking": 10,
  "skidThreshold": 12,
  "skidBraking": 16,
  "skidSteerFactor": 0.7,
  "turnRate": 140,
  "headingSmoothing": 8,
  "traverseFriction": 6,
  "minRollSpeed": 6,
  "overCapDecay": 2,
  "sharpTurnLoss": 0.15,
  "boostDrainPerS": 0.25,
  "boostRefillCleanLanding": 0.15,
  "boostRefillPerTrickPoint": 0.0002,
  "boostPassiveRefillPerS": 0.01,
  "crashDurationS": { "small": 0, "medium": 1.2, "large": 2.5 },
  "invulnerableS": 1
}
